var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorisAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 1300,
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#B5E2DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_635",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1301,
    height: 1300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1014 1197.33C1010.97 1199.5 1007.5 1201.66 1004.47 1203.83C1001 1206 997.967 1208.16 994.5 1209.9C991.467 1211.63 988.867 1213.36 985.833 1215.1C985.4 1215.53 984.967 1215.53 984.533 1215.96C974.567 1222.03 964.167 1227.66 953.767 1232.86C950.733 1234.6 947.267 1236.33 944.233 1237.63C944.233 1237.63 943.8 1238.06 943.367 1238.06C939.9 1239.8 936.433 1241.53 932.967 1243.26C926.033 1246.73 918.667 1249.76 911.733 1252.8C908.267 1254.53 904.367 1255.83 900.9 1257.13C897.433 1258.43 893.533 1260.16 890.067 1261.46C886.6 1262.76 882.7 1264.5 879.233 1265.8C879.233 1265.8 879.233 1265.8 878.8 1265.8C875.333 1267.1 871.433 1268.4 867.967 1269.7C860.167 1272.3 851.933 1274.9 844.133 1277.5C841.533 1278.36 838.5 1279.23 835.9 1280.1C827.667 1282.7 819.433 1284.86 811.2 1286.6C808.167 1287.46 805.133 1287.9 801.667 1288.76C793.867 1290.5 785.633 1292.23 777.833 1293.96C776.1 1294.4 774.8 1294.4 773.067 1294.83C770.467 1295.26 767.433 1295.7 764.833 1296.13C760.933 1296.56 757.467 1297.43 753.567 1297.86C751.833 1298.3 750.1 1298.3 748.367 1298.73C746.2 1299.16 743.6 1299.6 741 1299.6C734.067 1300.46 726.7 1301.33 719.767 1302.2C717.6 1302.63 715 1302.63 712.833 1303.06H712.4C709.367 1303.5 706.333 1303.5 703.3 1303.93C700.267 1304.36 697.233 1304.36 694.2 1304.36C692.467 1304.36 690.3 1304.8 688.567 1304.8C685.1 1304.8 682.067 1305.23 679.033 1305.23C674.7 1305.23 670.8 1305.66 666.467 1305.66C662.133 1305.66 658.233 1305.66 653.9 1305.66C650.867 1305.66 647.833 1305.66 644.8 1305.66C462.367 1303.06 297.7 1225.5 180.7 1102.43C180.7 1102.43 180.7 1102 180.267 1102C193.7 1075.56 243.534 1027.9 295.534 988.465C361.4 938.632 454.567 907.865 454.567 907.865C454.567 907.865 515.667 897.898 742.3 945.132C915.2 981.532 988.867 1129.3 1014 1197.33Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.4 1065.16C781.3 1109.8 722.367 1136.23 623.134 1096.36C501.367 1046.96 454.567 907.865 454.567 907.865C448.067 808.198 432.9 722.832 432.9 722.832C573.734 710.698 740.134 875.365 740.134 875.365L759.2 956.832C760.934 963.765 764.4 969.832 769.6 974.165C778.7 989.765 796.467 1036.56 790.4 1065.16Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.6 974.599C686.833 970.265 625.733 958.132 560.3 840.699C615.767 889.665 681.2 908.299 750.1 916.965L759.2 956.832C760.933 964.199 764.4 970.265 769.6 974.599Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.767 452.432C948.567 488.832 952.467 518.298 931.233 615.365C910 712.432 950.733 809.498 848.467 898.332C779.567 958.132 659.1 969.398 562.9 903.965C530.4 881.865 500.5 851.098 476.233 810.798C457.167 779.165 435.067 749.265 410.367 721.965C376.133 684.698 334.967 609.732 355.333 477.132C388.267 261.332 601.9 236.632 728 260.465C854.1 284.298 919.533 356.232 940.767 452.432Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.067 621.865C526.067 621.865 512.633 556.865 449.367 564.665C394.767 571.598 375.7 702.465 499.633 738.865",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.734 679.498C495.734 679.498 480.134 669.532 481.867 652.198C484.467 631.832 481.867 619.265 472.334 615.365C448.501 605.398 443.734 633.132 444.601 636.598",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.367 721.532C826.367 721.532 842.833 722.398 858.433 703.765C867.1 693.365 874.467 680.365 869.7 676.465C864.933 672.132 786.5 684.265 781.3 694.665C776.1 705.065 806.433 721.532 826.367 721.532Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.367 575.932C839.367 575.932 840.234 617.098 866.667 663.032C878.367 683.398 860.601 716.765 822.034 722.398",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1057.78 1116.61C996.25 1037.31 900.917 1004.37 848.483 984.873C844.15 963.206 835.917 939.373 822.917 916.406C802.983 928.54 780.017 937.64 756.184 942.406L759.65 956.706C761.383 963.64 770.05 995.706 756.617 1036.87C745.35 1071.54 699.85 1087.14 622.717 1052.04C472.35 984.006 455.017 907.306 455.017 907.306C452.417 865.706 448.084 826.706 444.184 795.073C397.384 805.473 343.217 826.706 313.75 871.34C277.35 925.94 263.917 981.406 267.384 1025.61C204.117 1065.91 106.184 1127.01 74.1168 1236.21C32.5168 1378.34 39.4502 1465.44 39.4502 1465.44H1159.18C1157.88 1465.87 1141.42 1224.51 1057.78 1116.61Z",
    fill: "#2D9CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.283 974.473C388.283 974.473 414.716 1077.17 530.416 1148.24Z",
    fill: "#2D9CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.283 974.473C388.283 974.473 414.716 1077.17 530.416 1148.24",
    stroke: "#2F80ED",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.05 984.873C848.05 984.873 878.817 1117.91 811.65 1179.01Z",
    fill: "#2D9CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.05 984.873C848.05 984.873 878.817 1117.91 811.65 1179.01",
    stroke: "#333333",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.183 1158.64C639.183 1158.64 616.65 1224.51 622.717 1270.01Z",
    fill: "#2D9CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.183 1158.64C639.183 1158.64 616.65 1224.51 622.717 1270.01",
    stroke: "#333333",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.417 1154.74C777.417 1154.74 794.318 1191.57 806.451 1250.07Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.417 1154.74C777.417 1154.74 794.318 1191.57 806.451 1250.07",
    stroke: "#333333",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.517 1026.04C266.517 1026.04 302.05 1170.77 513.517 1213.24Z",
    fill: "#2D9CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.517 1026.04C266.517 1026.04 302.05 1170.77 513.517 1213.24",
    stroke: "#2F80ED",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.617 1279.97L607.55 1278.24C600.617 1277.37 595.417 1270.87 596.717 1263.94L603.217 1231.44C604.95 1222.34 613.617 1215.84 622.717 1217.14C631.817 1218.01 639.183 1225.81 639.183 1235.34L639.617 1268.71C639.617 1275.21 633.55 1280.84 626.617 1279.97Z",
    fill: "#2D9CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.517 1260.04L807.317 1266.54C800.384 1269.14 793.017 1264.81 791.717 1257.87L783.917 1225.81C781.75 1216.71 786.517 1207.61 795.617 1204.14C804.284 1201.11 814.25 1205.01 818.15 1213.24L832.45 1243.14C835.484 1249.64 832.45 1257.44 825.517 1260.04Z",
    fill: "#2D9CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.62 1250.07C1016.62 1250.07 1040.88 1386.14 1031.35 1465.87",
    stroke: "#333333",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M683.943 619.439C673.543 619.006 665.743 610.339 666.61 599.939L667.043 587.806C667.476 577.406 676.143 569.606 686.543 570.473C696.943 570.906 704.743 579.573 703.876 589.973L703.443 602.106C703.01 612.073 694.343 619.873 683.943 619.439Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.375 625.939C856.842 625.506 849.475 617.272 849.909 607.739L850.342 596.472C850.775 586.939 859.009 579.572 868.542 580.006C878.075 580.439 885.442 588.672 885.009 598.206L884.575 609.472C884.142 619.006 875.909 626.372 866.375 625.939Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.977 594.306C725.977 594.306 714.71 578.273 695.21 575.239C679.177 572.639 661.41 580.439 658.81 589.539",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.809 598.206C853.809 598.206 853.809 584.339 873.743 584.339C890.209 584.339 897.143 599.506 897.143 599.506",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.743 524.539C752.843 527.573 761.943 519.339 760.209 509.373C759.343 504.173 757.176 498.973 752.843 495.073C739.843 483.373 686.109 472.973 653.609 488.139C625.009 502.006 702.143 510.673 743.743 524.539Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.308 531.473C865.941 534.073 858.141 526.273 859.441 517.173C859.874 512.406 861.608 507.639 865.074 504.173C875.474 493.773 911.008 485.539 933.541 501.573C953.041 515.006 907.108 518.906 873.308 531.473Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.697 770.764C768.997 785.497 725.231 769.464 704.864 744.764",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.719 247.358C398.052 236.525 322.652 457.525 344.319 584.058C365.552 706.258 443.119 762.592 443.119 762.592L495.552 744.392C495.552 744.392 475.185 737.458 455.685 723.158C388.519 672.025 409.319 579.292 455.252 573.225C501.185 567.592 520.685 600.525 528.052 618.725C552.319 538.558 518.085 518.625 552.319 461.858C659.352 346.158 735.619 419.392 786.319 439.325C832.685 457.525 862.585 434.992 888.152 411.158C903.319 396.858 924.985 400.758 924.985 400.758C924.985 400.758 895.519 257.758 653.719 247.358Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.007 730.178C829.007 730.178 812.974 695.945 753.607 717.178C715.474 731.045 678.207 752.711 657.407 730.178C657.407 730.178 668.241 786.511 735.841 798.645C819.041 812.945 836.807 755.745 829.007 730.178Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.54 724.978C825.54 724.978 850.24 701.578 874.074 723.678C895.74 743.611 906.14 746.645 913.94 734.511C913.94 734.511 915.674 782.178 877.974 788.245C836.807 795.178 821.64 762.245 821.64 762.245",
    fill: "#828282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_635",
    x: -4.98315,
    y: 755.073,
    width: 1379.72,
    height: 950.827,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_635"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_635",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorisAvatar);
export default __webpack_public_path__ + "static/media/boris-avatar.64616fca3a833893055758920121d44d.svg";
export { ForwardRef as ReactComponent };